export const isPageInvalid=(page,lastPage)=>page<1||page>lastPage&&0!==lastPage;